module.exports = __webpack_public_path__ + "assets/battery_swap_required.436f8360.svg";